import React, { useState, useEffect } from "react";
import "./DemoWelcome.css";
import { Swiper, SwiperSlide } from 'swiper/react'; // Use React Swiper components
import { EffectCube, Autoplay } from 'swiper/modules'; // Import specific modules
import 'swiper/css'; // Core Swiper styles
import 'swiper/css/effect-cube'; // Cube effect styles
import Image1 from "../Images/SImage_11.jpg";
import Image2 from "../Images/SImage_12.jpg";
import Image3 from "../Images/SImage_13.jpg";
import Image4 from "../Images/SImage_14.jpg";

const DemoWelcome=()=>{
    return(
        <>
            <div className="app-container1">
      <header className="header1">
        <div className="logo1">Balaji Badminton Academy</div>
        <nav className="navigation1">
          <a href="#">Home</a>
          <a href="#">Coaches</a>
          <a href="#">User</a>
          <a href="#">Pages</a>
          <a href="#">Blog</a>
          <a href="#">Contact Us</a>
        </nav>
        <div className="auth-buttons1">
          <button className="login-register1">Login/Register</button>
          {/* <button className="list-court1">List Your Court</button> */}
        </div>
      </header>

      <main className="main-content1">
      <div className="welcomedemo">
        <div className="hero-section1">
          <div className="hero-text1">
          <h5 className="demowelcomeh5">World Class Badminton Coaching & Premium Courts</h5>
            <p className="p">Choose Your <span>Coaches </span><br/>And Start Your Training</p>
            <p>Unleash Your Athletic Potential with Expert Coaching, State-of-the-Art Facilities,<br/> and Personalized Training Programs.</p>
          </div>
        </div>

        <Swiper
                            effect="cube"
                            grabCursor={true}
                            loop={true}
                            speed={1000}
                            modules={[EffectCube, Autoplay]}
                            cubeEffect={{
                                shadow: true,
                                slideShadows: true,
                                shadowOffset: 20,
                                shadowScale: 0.94,
                            }}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                            }}
                            className="swiper demowelcomeswiper"
                        >
                            <SwiperSlide>
                                <img src={Image4} alt="Slide 1" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src={Image1} alt="Slide 2" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src={Image2} alt="Slide 3" />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src={Image3} alt="Slide 4" />
                            </SwiperSlide>
                        </Swiper>
        </div>

        <div className="image-overlay1">
          <div className="shuttlecocks1">
            <div className="shuttlecock1"></div>
            <div className="shuttlecock1"></div>
          </div>
        </div>

        <div className="floating-elements1">
           <div className="floating-shuttlecock"></div>
        </div>

        <div className="floating-elements2"></div>
        <div className="floating-elements3"></div>
        <div className="blob-div1"></div>
        <div className="blob-div2"></div>
        <div className="blob-div3"></div>                   
      </main>
      
    </div>
        </>
    );
}

export default DemoWelcome;